import {
  formatMoney,
  Config,
  useFetchApi,
  useRedirect,
  Translator,
  ReplaceAllInstances,
  Button,
  enumsSetting,
} from "@itarget/shared";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ListItensCart from "./ListItensCart";
import Loading from "../Loading";
import {
  Typography,
  Grid,
  Paper,
  CardContent,
  TextField,
  CircularProgress,
  Box,
} from "@material-ui/core";
import { toast, payment as paymentRedux } from "../../redux";
import "./index.scss";
import { makeStyles } from "@material-ui/styles";
import { translate } from "../../utils/translation";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    backgroundColor: theme.palette.cardShopping.paper,
  },
  cardShopping: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    "& .shopping-card-title": {
      paddingBottom: theme.spacing(1),
      borderBottom: `${theme.spacing(0.125)}px solid ${
        theme.palette.grey["400"]
      }`,
    },
  },
  resumeContainer: {},
  textResume: {
    fontWeight: "bold",
    fontSize: theme.typography.pxToRem(18),
  },
  discountCashbackContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  discountCashbackLabel: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cashbackWallet.discountTextColor,
  },
  discountCashbackActionsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  discountCashbackRemoveButton: {
    flex: 0,
    padding: 0,
    position: "relative",
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "row-reverse",
    },
  },
  discountCashbackValue: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.cashbackWallet.discountTextColor,
  },
  totalContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  totalLabel: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cardShopping.totalLabel,
  },
  total: {
    lineHeight: 1.08,
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(26),
    color: theme.palette.cardShopping.total,
  },
  totalSymbol: {
    float: "inline-start",
    marginRight: theme.spacing(1),
    fontSize: theme.typography.pxToRem(16),
  },
}));

const CardShopping = ({
  fetchInscricoes,
  state,
  setState,
  selected,
  setSelected,
  user,
  courses,
  setting,
  appliedCashbackWallet = 0,
  handleCleanAppliedCashbackWallet = () => {},
}) => {
  const systemTheme = useSelector((state) => state.theme.systemTheme);
  const styles = useStyles({ theme: systemTheme });
  const { goTo } = useRedirect();
  const cloneDeep = require("clone-deep");
  const dispatch = useDispatch();
  const center_cost_id = useSelector((state) => state.auth.cc);
  const [total, setTotal] = useState(0);
  const selectedLang = useSelector((state) => state.language.lang);
  const [valueVoucher, setValueVoucher] = useState("");
  const [subscriptionIds, setSubscriptionIds] = useState("");
  const [accountReceiveIds, setAccountReceiveIds] = useState("");
  const [finalAmount, setFinalAmount] = useState([]);
  const [descriptionActivityPending, setDescriptionActivityPending] =
    useState("");
  const activeVoucher = setting?.data.find(
    (item) => item.codigo == enumsSetting.ACTIVE_VOUCHER
  );

  const {
    data: voucherPut,
    error: erroVoucherPut,
    fetchData: fetchVoucherPut,
    isLoading: isLoadingApllyVoucher,
  } = useFetchApi(
    Config.baseURL + `api/${selectedLang}/finance/voucher/apply`,
    "POST"
  );

  const {
    data: subscriptionComboApi,
    fetchData: fetchComboSubscription,
    isLoading: isLoadingComboSubscription,
  } = useFetchApi(
    Config.baseURL +
      `api/${selectedLang}/subscription/combo?pessoa_id=${
        user.data && user.data.id
      }&inscricao_id[]=${subscriptionIds}&conta_receber_id[]=${accountReceiveIds}`
  );

  const onChangeVoucher = (event) => {
    setValueVoucher(event.target.value);
    if (event.target.value != "") {
      setState("voucher");
    } else {
      setState("payment");
    }
  };

  const goFinishVoucher = async () => {
    goTo(`my-activity`);
  };

  const translation = {
    resume: translate("Resumo da compra"),
    empty: translate("Seu carrinho de compra está vazio!"),
    voucherTextLabel: translate("Cód. do Voucher"),
    emptyVoucher: translate("Preencha o campo com o código do voucher."),
    descriptionActivity: translate(
      "A atividade %s ainda está pendente. Por favor, realize o pagamento dessa atividade antes de prosseguir."
    ),
    cashbackDiscount: translate("DESCONTO EM CASH"),
    remove: translate("Remover"),
    calculate: translate("Calculando"),
    total: translate("Valor total"),
    applyVoucher: translate("Aplicar voucher"),
    finalize: translate("Finalizar"),
    goToPayment: translate("Ir para pagamento"),
  };

  const isValidReference = (value) => {
    if (value === null || value === undefined) {
      return false;
    }
    const normalized = String(value).trim().toLowerCase();
    return (
      normalized !== "" &&
      normalized !== "null" &&
      normalized !== "undefined"
    );
  };

  const getAccountReceiveIds = (value) => {
    if (Array.isArray(value)) {
      return value.filter(isValidReference);
    }

    if (value && typeof value === "object") {
      return Object.values(value).filter(isValidReference);
    }

    return isValidReference(value) ? [value] : [];
  };

  const getMergedSelectionByAccountReceive = () => {
    const merged = {};

    courses?.forEach((course) => {
      if (!course?.conta_receber_id) {
        return;
      }
      merged[String(course.conta_receber_id)] = course;
    });

    selected?.forEach((selection) => {
      getAccountReceiveIds(selection?.conta_receber_id).forEach(
        (accountReceiveId) => {
          const key = String(accountReceiveId);
          merged[key] = {
            ...selection,
            ...(merged[key] || {}),
            titulo: selection?.titulo || merged[key]?.titulo,
            descricao: selection?.descricao || merged[key]?.descricao,
          };
        }
      );
    });

    return merged;
  };

  const resolvePaymentReferenceFromRow = (row) => {
    if (!row) {
      return null;
    }

    if (isValidReference(row.centro_custo_referencia_cobranca_id)) {
      return String(row.centro_custo_referencia_cobranca_id);
    }

    const paymentRules = Array.isArray(row.contas_receber_regras_pagamento)
      ? row.contas_receber_regras_pagamento
      : [];
    const ruleWithReference = paymentRules.find((rule) =>
      isValidReference(rule?.centro_custo_referencia_cobranca_id)
    );

    if (ruleWithReference) {
      return String(ruleWithReference.centro_custo_referencia_cobranca_id);
    }

    return null;
  };

  const getConflictPaymentMessage = () => {
    const mergedByAccountReceive = getMergedSelectionByAccountReceive();
    const selectedRows = (selected || []).reduce((rows, selection) => {
      const accountReceiveIds = getAccountReceiveIds(selection?.conta_receber_id);

      if (!accountReceiveIds.length) {
        return [...rows, selection];
      }

      return [
        ...rows,
        ...accountReceiveIds.map(
          (accountReceiveId) =>
            mergedByAccountReceive[String(accountReceiveId)] || selection
        ),
      ];
    }, []);
    const selectedWithReference = selectedRows
      .map((sourceSelection) => {
        return {
          titulo: sourceSelection?.titulo || sourceSelection?.descricao,
          reference: resolvePaymentReferenceFromRow(sourceSelection),
        };
      })
      .filter(({ reference }) => isValidReference(reference));

    const uniqueReferences = Array.from(
      new Set(selectedWithReference.map(({ reference }) => reference))
    );

    if (uniqueReferences.length < 2) {
      return "";
    }

    const conflictTitles = uniqueReferences
      .slice(0, 2)
      .map(
        (reference) =>
          selectedWithReference.find((item) => item.reference === reference)
            ?.titulo
      );

    return `A cobranca do conta a receber "${conflictTitles[0]}" e "${conflictTitles[1]}" O pagamento das mesmas, não pode ser realizado Juntas. Escolha somente  um deles para fazer o pagamento agora.`;
  };

  const confirmVoucher = async (eventSubmit) => {
    eventSubmit.preventDefault();
    if (!valueVoucher) {
      dispatch(
        toast.actions.enqueue({
          content: translation.emptyVoucher,
          severity: "error",
        })
      );
      return;
    }
    await fetchVoucherPut(
      JSON.stringify({
        origem_pessoa_id: user.data.id,
        centro_custo_id: center_cost_id,
        amount: total,
        subscription: selected,
        voucher: valueVoucher,
      })
    );
    if (!erroVoucherPut) {
      await fetchInscricoes();
      setValueVoucher("");
      window.scrollTo(0, document.body.scrollHeight);
    }
  };

  useEffect(() => {
    if (descriptionActivityPending) {
      dispatch(
        toast.actions.enqueue({
          content: ReplaceAllInstances(translation.descriptionActivity, [
            descriptionActivityPending,
          ]),
          severity: "error",
        })
      );
    }
    setDescriptionActivityPending("");
  }, [descriptionActivityPending]);

  const goPayment = () => {
    const conflictPaymentMessage = getConflictPaymentMessage();
    if (conflictPaymentMessage) {
      dispatch(
        toast.actions.enqueue({
          content: conflictPaymentMessage,
          severity: "error",
        })
      );
      return;
    }

    const pendingActivity = selected.find((select) =>
      select.pre_agenda_atividades?.some(
        (pre_agenda) =>
          pre_agenda.status_inscricao !== 2 &&
          !selected.some(
            (atividade) =>
              atividade.agenda_atividade_id ===
              pre_agenda.agenda_atividade_pre_id
          )
      )
    );

    if (!(total > 0)) {
      dispatch(
        toast.actions.enqueue({
          content: translation.empty,
          severity: "error",
        })
      );
      return;
    } else if (pendingActivity) {
      setDescriptionActivityPending(
        pendingActivity.pre_agenda_atividades.find(
          (pre_agenda) =>
            pre_agenda.status_inscricao !== 2 &&
            !selected.some(
              (atividade) =>
                atividade.agenda_atividade_id ===
                pre_agenda.agenda_atividade_pre_id
            )
        ).descricao
      );

      return;
    }
    document.documentElement.scroll({
      top: 0,
      left: 0,
    });
    setState("payment");
  };

  useEffect(() => {
    setSubscriptionIds(selected?.map((res) => res.inscricao_uuid).join(","));
    setAccountReceiveIds(
      selected?.map((res) => res.conta_receber_id).join(",")
    );
    setTotal(0);

    function valueVoucher(value, descountType, descount) {
      if (descountType === "P") {
        value = value * (parseFloat(descount) / 100);
      } else if (descountType === "V") {
        value = parseFloat(descount);
      }
      return value;
    }
    setFinalAmount([]);

    if (subscriptionComboApi?.data?.length) {
      // Usar os dados da API combo que já contém os valores corretos
      subscriptionComboApi.data.forEach((item) => {
        let value = parseFloat(item.valor || 0);
        
        // Aplicar desconto se existir
        if (item.valor_desconto) {
          value = value - parseFloat(item.valor_desconto);
        }
        
        // Aplicar voucher se existir
        if (item.tipo_desconto_voucher && item.valor_voucher) {
          const voucherDiscount = valueVoucher(
            value,
            item.tipo_desconto_voucher,
            item.valor_voucher
          );
          value = value - voucherDiscount;
        }
        
        finalAmount.push(value);
      });
    } else {
      // Fallback para quando não há dados da API combo
      selected?.forEach((row) => {
        let value = parseFloat(row.cr_valor || row.valor || 0);
        
        //removido por conta de um erro na tarefa 
        // // Aplicar desconto se existir
        // if (row.valor_desconto) {
        //   value = value - parseFloat(row.valor_desconto);
        // }
        
        finalAmount.push(value);
      });
    }

    if (appliedCashbackWallet) {
      finalAmount.push(-parseFloat(appliedCashbackWallet));
    }
    setTotal(
      selected?.length > 0 && finalAmount?.length > 0
        ? finalAmount.reduce(
            (amount1, amount2) => (amount1 || 0) + (amount2 || 0)
          )
        : 0
    );
  }, [selected, subscriptionComboApi, appliedCashbackWallet]);

  useEffect(() => {
    if (subscriptionIds && subscriptionIds?.split(",").length > 0) {
      fetchComboSubscription();
    }
  }, [subscriptionIds]);

  useEffect(() => {
    dispatch(paymentRedux.actions.setTotal(total));
  }, [total]);

  useEffect(() => {
    if (!isLoadingApllyVoucher) {
      if (erroVoucherPut) {
        dispatch(
          toast.actions.enqueue({
            content: erroVoucherPut,
            severity: "error",
          })
        );
      }
      if (voucherPut?.message) {
        dispatch(
          toast.actions.enqueue({
            content: voucherPut.message,
            severity: "success",
          })
        );
      }
    }
  }, [isLoadingApllyVoucher]);

  useEffect(() => {
    if (voucherPut?.data?.id && selected.length > 0) {
      const descount = voucherPut.data.voucher.desconto;
      const descountType = voucherPut.data.voucher.tipo_desconto;
      let selected2 = cloneDeep(selected);
      setSelected(
        selected2.map((row) => {
          if (voucherPut.data.id === row.inscricao_uuid) {
            if (descountType === "P") {
              row.valor_desconto = row.valor * (parseFloat(descount) / 100);
            } else if (descountType === "V") {
              row.valor_desconto = parseFloat(descount);
            }
            setValueVoucher("");
          }
          return row;
        })
      );

      setState("payment");
      dispatch(paymentRedux.actions.setCodVoucher(valueVoucher));
      fetchComboSubscription();
    }
  }, [voucherPut]);
  return (
    <Paper className={`resumoCompra ${styles.paperContainer}`}>
      <CardContent>
        <Grid className={`shoppingCard ${styles.cardShopping}`}>
          <Typography className={styles.textResume}>
            {translation.resume}
          </Typography>
          <Grid className={styles.resumeContainer}>
            {isLoadingComboSubscription && <Loading />}
            {!isLoadingComboSubscription && (
              <ListItensCart
                selected={selected}
                subscriptionComboApi={subscriptionComboApi}
              />
            )}
            {!!appliedCashbackWallet && (
              <Box className={styles.discountCashbackContainer}>
                <Typography className={styles.discountCashbackLabel}>
                  {translation.cashbackDiscount}
                </Typography>
                <Box className={styles.discountCashbackActionsContainer}>
                  <Button
                    color="error"
                    icon="delete"
                    variant="text"
                    onClick={handleCleanAppliedCashbackWallet}
                    className={styles.discountCashbackRemoveButton}
                  >
                    {translation.remove}
                  </Button>
                  <Typography className={styles.discountCashbackValue}>
                    - R$ {formatMoney.toReal(appliedCashbackWallet)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Grid>

          {isLoadingComboSubscription && (
            <Typography className="text-sum">
              {translation.calculate}...
            </Typography>
          )}
          {!isLoadingComboSubscription && (
            <Grid className={styles.totalContainer}>
              <Typography className={styles.totalLabel}>
                {translation.total}
              </Typography>
              <Typography className={styles.total}>
                <span className={styles.totalSymbol}>R$</span>
                {formatMoney.toReal(total)}
              </Typography>
            </Grid>
          )}
          {(state === "payment" || state === "voucher") &&
            total !== 0 && (activeVoucher?.ativo == "S" && activeVoucher?.valor_referencia == "S") &&
            !appliedCashbackWallet && (
              <Grid item>
                <form autoComplete="off" onSubmit={confirmVoucher}>
                  <Grid container direction="column" spacing={1}>
                    <Grid container item>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-voucher-textfield"
                        label={translation.voucherTextLabel}
                        autoComplete="off"
                        variant="outlined"
                        name="voucher"
                        value={valueVoucher}
                        onChange={(e) => onChangeVoucher(e)}
                      />
                    </Grid>
                    <Grid container item>
                      <Button
                        id="submit-voucher-button"
                        variant="midnight"
                        color="midnight"
                        type="submit"
                      >
                        {isLoadingApllyVoucher ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          translation.applyVoucher
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            )}

          {state === "payment" && total === 0 && (
            <Button
              variant="midnight"
              color="midnight"
              onClick={() => goFinishVoucher()}
            >
              {translation.finalize}
            </Button>
          )}

          {state === "cards" && (
            <Button
              variant="contained"
              color="error"
              onClick={() => goPayment()}
            >
              {translation.goToPayment}
            </Button>
          )}
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default CardShopping;
